
import { FormElementController, FormPageValidator, FormElementValidator, StringValidators, IValidatingObject } from './../../../scripts/formcontrols'
import { DrugDto } from "./../../../dto/DrugDto"
import Dal from './../../../scripts/dataaccess';
import { WardCycleDto, PatientOrderItemDto, DispensationItemDto, MedRoundDto } from './../../../dto/Dtos';
import { PatientDto } from './../../../dto/PatientDto';
import RoundSelectorController from '../RoundSelector/RoundSelectorController';
import { WardDto } from '../../../dto/WardDto';
import DispensationItemController from './DispensationItemController'

export class PatientMedProfile2Controller extends FormPageValidator {

    patient: PatientDto = new PatientDto();
    cycle   : WardCycleDto      = new WardCycleDto();
    ward    : WardDto           = new WardDto();
    originalItems: Array<DispensationItemDto> = [];
    
    private IsInitialized: boolean = false;
    public IsLoading: boolean = false;;
    public DispensationItems: Array<DispensationItemController> = []
    
    public Initialize(cycle: WardCycleDto, patient: PatientDto, ward: WardDto) {

        console.log("Initializing Controller ", patient, cycle, ward)
        this.patient = patient;
        this.cycle = cycle;
        this.ward = ward;

        this.IsInitialized = true;
        this.IsLoading = true;

        this.Load();
    }
    public get ChangeCount(): number {
        return this.DispensationItems.filter(i => i.HasChanged).length;
    }
    public Load() {
        var dal = new Dal();
        console.log("Loading Controller ", this.patient.id, this.cycle.startDate, this.cycle.endDate)
        dal.GetDispensationItems(this.patient.id, this.cycle.startDate, this.cycle.endDate)
            .then(data => {
                console.log("Loading Controller data", data)
                this.originalItems = data;
                this.DispensationItems = data.map(d => new DispensationItemController(this.cycle, this.patient, this.ward, d));
                this.addValidatorsArray(this.DispensationItems as IValidatingObject[]);
                this.IsLoading = false
            });        
    }


    public CreateItem() {
        var newItem = new DispensationItemController(this.cycle, this.patient, this.ward);
        this.DispensationItems.push(newItem);
        //this.addValidator(newItem as IValidatingObject);
        //this.addValidator(newItem  as IValidatingObject);
    }


    public RemoveItem(item: DispensationItemController) {
        this.DispensationItems.splice(this.DispensationItems.indexOf(item), 1);
        this.removeValidator(item as IValidatingObject);
    }

    public Reset() {
        this.Load();
    }
    public Save() {
        var items = this.DispensationItems.filter(i => i.HasChanged || i.IsNew).map(d => d.GetItem());
        var dal = new Dal()
        console.log("PAtientMEdPRofile2Controller.Save")
        return dal.UpdateDispensationItems(this.patient.id, this.cycle.startDate, this.cycle.endDate, items)
            .then(() => {
                this.Load()
            })
    }
}


// WEBPACK FOOTER //
// ./ClientApp/components/appcontrols/PatientMedProfile2/PatientMedProfile2Controller.ts